import axios from 'axios'

export const geocodeFromGooglePlace = async (googlePlace) => {
    return await axios({
        method: "post",
        url: "/api/pc_miler/geocode_from_google_place",
        data: googlePlace
    })
}